import { Card } from "@/components/ui/card";
import { Fingerprint } from "lucide-react";
import HeaderProfileGroup from "@/components/TopBar";

export default function Pointage() {
  return (
    <div data-testid="pointage-page">
      <div className="flex items-start justify-between gap-4 mb-2">
        <h1 className="text-4xl font-bold">Pointage</h1>
        <HeaderProfileGroup />
      </div>
      <p className="text-muted-foreground mb-8">
        Suivi des présences de l'équipe (visible uniquement par les administrateurs).
      </p>
      <Card className="bg-card border-vertec-borderDark p-12 text-center">
        <div
          className="w-14 h-14 rounded-lg mx-auto mb-4 flex items-center justify-center"
          style={{ background: "#8B451322", color: "#8B4513" }}
        >
          <Fingerprint size={26} />
        </div>
        <h3 className="text-xl font-semibold mb-2">Module en préparation</h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          Les spécifications détaillées du module Pointage seront ajoutées prochainement.
        </p>
      </Card>
    </div>
  );
}
